class MMProductPicker extends HTMLElement {
    constructor() {
      super();
        this.container = this.querySelector('.product-picker-list');
    }

    connectedCallback() {
      this.init();
    }
    
    init() {
        const product_list = this.container.querySelectorAll('.product-picker-item');
        //console.log('Load product picker!', this.picker_list);
        product_list.forEach((item, index) => {
            item.addEventListener('click', (event) => {
                event.preventDefault();
                const p_handle = item.dataset.productHandle;
                //console.log('Click product picker item!', p_handle);
                let section_html = mm_products_data[p_handle];
                this.updateProductSection(section_html, p_handle, item.dataset.productId);
                //console.log(item.dataset.productHandle);
                //this.handleTabButtonClick(event, index);
                setTimeout(() => {                  
                  MarkdownPricePro.run();
                }, 700);
            });
        })
    }

    updateProductSection(html, product_handle, product_id) {
        const new_content = new DOMParser()
            .parseFromString(html, "text/html");
        const nc = new_content.querySelector('.wt-product__main');
        let new_content_gallery = new_content.querySelector("gallery-section");
        let new_product_title = nc.querySelector(".wt-product__name");
        let new_product_tags = nc.querySelector(".card__tags.pdp__tags");
        let new_product_price = nc.querySelector(".wt-product__price");
        let new_product_short_description = nc.querySelector(".short-description");

        let new_product_color_dots = nc.querySelector(".product-picker");
        let new_product_options = nc.querySelector(".wt-product__options");
        let new_product_add_to_cart_form = nc.querySelector(".wt-product__add-to-cart_form");
        
        // New product meta tags
        let new_meta_name = new_content.querySelector('meta[itemprop="name"]');
        let new_meta_url = new_content.querySelector('meta[itemprop="url"]');
        let new_meta_brand = new_content.querySelector('meta[itemprop="brand"]');
        let new_meta_image = new_content.querySelector('meta[itemprop="image"]');
        let new_meta_description = new_content.querySelector('meta[itemprop="description"]');

        if (!new_content) {
            console.error("Error: Product form not found in the response!");
            return;
        }
        const ppc = document.querySelector('.product-picker-container');
        const content_gallery = ppc.querySelector('gallery-section');
        const product_title = ppc.querySelector('.wt-product__name');
        const product_tags = ppc.querySelector('.card__tags.pdp__tags');
        const product_price = ppc.querySelector('.wt-product__price');
        const product_short_description = ppc.querySelector('.wt-product__price');

        const product_rating = ppc.querySelector('.yotpo-widget-instance');

        const product_color_dots = ppc.querySelector('.product-picker');
        const product_options = ppc.querySelector('.wt-product__options');
        const product_add_to_cart_form = ppc.querySelector('.wt-product__add-to-cart_form');

        // Product meta tags
        const meta_name = document.querySelector('meta[itemprop="name"]');
        const meta_url = document.querySelector('meta[itemprop="url"]');
        const meta_brand = document.querySelector('meta[itemprop="brand"]');
        const meta_image = document.querySelector('meta[itemprop="image"]');
        const meta_description = document.querySelector('meta[itemprop="description"]');
        
        if (new_content) {
            setTimeout(() => {
                // Replace the content of the product form
                meta_name.content = new_meta_name.content;
                meta_url.content = new_meta_url.content;
                meta_brand.content = new_meta_brand.content;
                meta_image.content = new_meta_image.content;
                meta_description.content = new_meta_description.content;

                content_gallery.replaceWith(new_content_gallery);
                product_title.replaceWith(new_product_title);
                product_tags.replaceWith(new_product_tags);
                
                product_price.replaceWith(new_product_price);
                product_short_description.replaceWith(new_product_short_description);
                //product_rating.replaceWith(new_product_rating);
                product_color_dots.replaceWith(new_product_color_dots);
                product_options.replaceWith(new_product_options);
                product_add_to_cart_form.replaceWith(new_product_add_to_cart_form);
                
                document.dispatchEvent(new CustomEvent('product:product-picker:click', {
                    detail: {
                    product_handle: product_handle
                    },
                }));
                if (product_id) {
                    product_rating.setAttribute("data-yotpo-product-id", product_id)
                    this.refreshYotpo();    
                }
            }, 10);
    
            //history.pushState({}, "", `/products/${product_handle}`);
    
        } else {
            console.error("Error: Product form container not found in the document!");
        }
    }
    refreshYotpo() {
        if (typeof yotpo !== "undefined" && yotpo.refreshWidgets) {
            yotpo.refreshWidgets();
        }
    }
}
  
customElements.define("product-picker-list", MMProductPicker);